import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Link,
} from "@mui/material";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Dispatch } from "@reduxjs/toolkit";
import { addToken, login } from "../../redux/reducer/features/Auth/authSlice";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PageLoader from "../app/PageLoader";
import { LoginFormValues } from "../../pages/Auth/Login";

const LoginInitialValues: LoginFormValues = {
  dmsDealerId: "",
  username: "",
  password: "",
};

const Schema = Yup.object<any>().shape<any>({
  dmsDealerId: Yup.string()
    .max(50, "dealer Id can only be upto 50 characters")
    .required("Dealer ID is required"),
  username: Yup.string()
    .max(50, "Username can only be upto 50 characters")
    .required("Username is required"),
  password: Yup.string()
    .max(100, "Password can only be upto 100 characters")
    .required("Password is required"),
});
interface DealerLoginProps {
  handleSetLoginType: any;
}
export const DealerLogin: React.FunctionComponent<DealerLoginProps> = ({
  handleSetLoginType,
}) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let idmsAccesstokan = urlSearchParams.get("idmsAccesstokan");
  const navigate = useNavigate();
  const dispatch = useDispatch<Dispatch<any>>();
  const [isLoading, setIsloading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPasswordChange = () => setShowPassword(!showPassword);
  const [isError, setIsError] = React.useState(false);
  const onLoginComplete = () => {
    setIsloading(true);
    navigate("/");
  };
  const onError = () => {
    setIsloading(false);
    setIsError(true);
  };
  const handleOnSubmit = (values: LoginFormValues) => {
    setIsloading(true);
    dispatch(login(values, onLoginComplete, onError));
  };

  useEffect(() => {
    if (idmsAccesstokan) {
      setIsloading(true);
      dispatch(
        login(
          { dmsDealerId: "", idmsToken: idmsAccesstokan },
          onLoginComplete,
          onError
        )
      );
    }
  }, []);
  return (
    <>
      <PageLoader isLoading={isLoading}></PageLoader>

      <Formik
        initialValues={LoginInitialValues}
        validationSchema={Schema}
        onSubmit={(values) => {
          handleOnSubmit(values);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur }) => (
          <>
            <Form
              style={{
                width: "100%",
              }}
            >
              <Card variant="outlined">
                <CardContent>
                  <TextField
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    type="text"
                    name="dmsDealerId"
                    autoComplete="dmsDealerId"
                    id="dmsDealerId"
                    label="Dealer Number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.dmsDealerId}
                    error={!!(touched.dmsDealerId && errors.dmsDealerId)}
                    helperText={touched.dmsDealerId ? errors.dmsDealerId : ""}
                  />
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    margin="dense"
                    name="username"
                    id="username"
                    label="Username"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.username}
                    error={!!(touched.username && errors.username)}
                    helperText={touched.username ? errors.username : ""}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="password"
                    margin="dense"
                    id="password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    error={!!(touched.password && errors.password)}
                    helperText={touched.password ? errors.password : ""}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            id="passwordVisibilityBtn"
                            onClick={handleShowPasswordChange}
                          >
                            {showPassword ? (
                              <VisibilityIcon />
                            ) : (
                              <VisibilityOffIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {isError === true ? (
                    <Typography
                      align="left"
                      variant="body1"
                      color={"error"}
                      gutterBottom
                    >
                      Invalid Credentials
                    </Typography>
                  ) : (
                    ""
                  )}
                  <Box mt={2}>
                    <Button
                      color="primary"
                      variant="contained"
                      type="submit"
                      fullWidth
                    >
                      Login
                    </Button>
                    {/* <Link
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "flex-start",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleSetLoginType("customer");
                      }}
                    >
                      Customer Login
                    </Link> */}
                  </Box>
                </CardContent>
              </Card>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default DealerLogin;
